// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gIuE","name":"styles_name__2kosQ","phone":"styles_phone__ft1qj"};